<template>
  <div>
    <md-app-toolbar>
      <div class="md-toolbar-row">
        <BuildingStockHeader :site-id="parseInt($route.params.siteId)" />
      </div>
    </md-app-toolbar>
    <div class="page-container">
      <md-app
        md-mode="fixed">
        <md-app-content class="page-content">
          <div class="page-layout">
            <div class="main__panel">
              <md-content>
                <div class="md-display-1">
                  Site {{ siteDetails.name }}
                  <span
                    @click="showSiteDetailsCommentDialog = true"
                    v-if='siteDetails.comment'>
                    <md-icon class="comment-icon">comment</md-icon>
                  </span>
                </div>
                <div class="md-title m-16">Données historiques du site</div>
                <template
                  v-if='siteConsumptionsCount > 0'>
                  <div
                    class="md-layout md-gutter">
                    <div class="md-layout-item">
                      <template>
                        <div>
                          <div class="float-right">
                            <md-radio
                              v-model="valuesType"
                              value="areal"
                              class="md-primary">
                              Valeurs surfaciques
                            </md-radio>
                            <md-radio
                              v-model="valuesType"
                              value="absolute"
                              class="md-primary">
                              Valeurs absolues
                            </md-radio>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <md-card>
                    <md-card-content>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <BarChart
                            :options="consumptionChart.chartOptions"
                            :chart-data="consumptionChart.dataCollection"
                            :gen-legend="false"/>
                        </div>
                        <div class="md-layout-item">
                          <BarChart
                            :options="outgoingsChart.chartOptions"
                            :chart-data="outgoingsChart.dataCollection"
                            :gen-legend="false"/>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>

                  <md-card>
                    <md-card-content>
                      <div
                        v-if='hasPagination'>
                        <div
                          @click='paginatePrevious()'>
                          <i
                            class="material-icons"
                            v-if="hasPreviousPagination">
                            navigate_before
                          </i>
                        </div>
                        <div
                          @click='paginateNext()'>
                          <i
                            class="material-icons"
                            v-if="hasNextPagination">
                            navigate_next
                          </i>
                        </div>
                      </div>

                      <md-table>
                        <md-table-row>
                          <md-table-head/>
                          <md-table-head
                            v-for='year in paginatedSiteData.years'
                            :key="`header-year-${year}`">
                            {{ year }}
                          </md-table-head>
                        </md-table-row>

                        <md-table-row>
                          <md-table-cell><strong>Consommation d'énergie finale (sans correction climatique)</strong></md-table-cell>
                          <md-table-cell
                            v-for='(consumption, i) in paginatedSiteData.totalConsumptions'
                            :key="`total-consumption-${i}`">
                            {{ consumption|formatIntNumber }} kWh
                          </md-table-cell>
                        </md-table-row>

                        <md-table-row
                          v-for='energyConsumptions in paginatedSiteData.energiesConsumptions'
                          :key="`energy-consumption-${energyConsumptions.energy.id}`"
                          class="md-selected">
                          <md-table-cell>{{ energyConsumptions.energy.label }}</md-table-cell>
                          <md-table-cell
                            v-for='(annualConsumption, i) in energyConsumptions.annualConsumptions'
                            :key="`annual-consumption-${i}`">{{ annualConsumption|formatIntNumber }}</md-table-cell>
                        </md-table-row>

                        <md-table-row>
                          <md-table-cell><strong>Dépenses en euros</strong></md-table-cell>
                          <md-table-cell
                            v-for='(outgoing, i) in paginatedSiteData.totalOutgoings'
                            :key="`total-outgoing-${i}`">
                            {{ outgoing|formatIntNumber }} €
                          </md-table-cell>
                        </md-table-row>

                        <md-table-row
                          v-for='energiesOutgoings in paginatedSiteData.energiesOutgoings'
                          :key="`energy-outgoings-${energiesOutgoings.energy.id}`"
                          class="md-selected">
                          <md-table-cell>{{ energiesOutgoings.energy.label }}</md-table-cell>
                          <md-table-cell
                            v-for='(annualOutgoing, i) in energiesOutgoings.annualOutgoings'
                            :key="`annual-outgoing-${i}`">{{ annualOutgoing|formatIntNumber }}</md-table-cell>
                        </md-table-row>

                        <md-table-row>
                          <md-table-cell><strong>Abonnements en euros</strong></md-table-cell>
                          <md-table-cell
                            v-for='(subscription, i) in paginatedSiteData.totalSubscriptions'
                            :key="`total-subscription-${i}`">
                            {{ subscription|formatPrice }} €
                          </md-table-cell>
                        </md-table-row>

                        <md-table-row
                          v-for='energiesSubscriptions in paginatedSiteData.energiesSubscriptions'
                          :key="`energy-subscriptions-${energiesSubscriptions.energy.id}`"
                          class="md-selected">
                          <md-table-cell>{{ energiesSubscriptions.energy.label }}</md-table-cell>
                          <md-table-cell
                            v-for='(annualSubscription, i) in energiesSubscriptions.annualSubscriptions'
                            :key="`annual-subscription-${i}`">{{ annualSubscription|formatPrice }}</md-table-cell>
                        </md-table-row>
                      </md-table>
                    </md-card-content>
                  </md-card>
                </template>
                <template
                  v-else>
                  <md-empty-state
                    md-icon="line_weight"
                    md-label="Aucune donnée historique"
                    md-description="Aucune donnée de consommation historique pour ce site." />
                </template>
              </md-content>
            </div>
          </div>
        </md-app-content>
      </md-app>
    </div>
    <md-dialog
      :md-fullscreen="false"
      :md-active.sync="showSiteDetailsCommentDialog">
      <md-dialog-title>Commentaires {{ siteDetails.name }}</md-dialog-title>
      <md-dialog-content>{{ siteDetails.comment }}</md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="showSiteDetailsCommentDialog = false">
          Fermer
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import session from '../api/session'
import axios from 'axios'
import BuildingStockHeader from '../components/BuildingStockHeader.vue'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'
import BarChart from '../components/BarChart.vue'
import ChartValuesMixin from '../mixins/ChartValuesMixin'

export default {
  name: 'BuildingStockSiteDetails',
  mixins: [ValuesDisplayMixin, ChartValuesMixin],
  components: { BuildingStockHeader, BarChart },
  data () {
    return {
      energyList: [],
      siteEnergyList: [],
      energyColorList: ['#795548', '#4CAF50', '#03A9F4', '#FF9800', '#9C27B0', '#E91E63', '#FFEB3B', '#8BC34A', '#2196F3', '#FF5722', '#673AB7', '#F44336', '#FFC107', '#009688', '#3F51B5', '#CDDC39', '#9E9E9E', '#607D8B', '#00BCD4'],
      siteDetails: {},
      showSiteDetailsCommentDialog: false,
      siteConsumptions: [],
      siteConsumptionsCount: 0,
      valuesType: 'areal',
      consumptionChart: {
        dataCollection: null,
        chartOptions: {},
        dataLabels: []
      },
      outgoingsChart: {
        dataCollection: null,
        chartOptions: {},
        dataLabels: []
      },
      hasPagination: false,
      hasPreviousPagination: false,
      hasNextPagination: false,
      paginationLimit: 5,
      paginationOffset: 0,
      paginationIndexMin: 0,
      paginationIndexMax: 5
    }
  },
  mounted: function () {
    var app = this
    app.loadApi()
  },
  watch: {
    valuesType: {
      handler (val) {
        this.loadApi()
      }
    }
  },
  computed: {
    paginatedSiteData () {
      var app = this
      var sliceMin = app.paginationIndexMin
      var sliceMax = app.paginationIndexMax

      var siteConsumptions = {
        years: [],
        totalConsumptions: [],
        energiesConsumptions: [],
        totalOutgoings: [],
        totalSubscriptions: [],
        energiesOutgoings: [],
        energiesSubscriptions: []
      }

      app.siteConsumptions.forEach(function (consumptionYear) {
        siteConsumptions.years.push(consumptionYear.year)
        siteConsumptions.totalConsumptions.push(consumptionYear.total_energy_consumption)
        siteConsumptions.totalSubscriptions.push(consumptionYear.total_subscription_invoice)
        siteConsumptions.totalOutgoings.push(consumptionYear.total_costs)
      })

      siteConsumptions.years = siteConsumptions.years.slice(sliceMin, sliceMax)
      siteConsumptions.totalConsumptions = siteConsumptions.totalConsumptions.slice(sliceMin, sliceMax)
      siteConsumptions.totalOutgoings = siteConsumptions.totalOutgoings.slice(sliceMin, sliceMax)
      siteConsumptions.totalSubscriptions = siteConsumptions.totalSubscriptions.slice(sliceMin, sliceMax)

      app.siteEnergyList.forEach(function (energy) {
        var energyConsumptions = {
          energy: energy,
          annualConsumptions: []
        }

        var energiesOutgoings = {
          energy: energy,
          annualOutgoings: []
        }

        var energiesSubscriptions = {
          energy: energy,
          annualSubscriptions: []
        }

        app.siteConsumptions.forEach(function (consumptionYear) {
          if (consumptionYear.place_energy_years.findIndex(function (i) { return i.energy === energy.id }) !== -1) {
            var energyConsumption = 0
            var energyOutgoing = 0
            var energySubscription = 0

            consumptionYear.place_energy_years.forEach(function (placeEnergyYear) {
              if (placeEnergyYear.energy === energy.id) {
                energyConsumption += parseFloat(placeEnergyYear.total_energy_consumption)
                energyOutgoing += parseFloat(placeEnergyYear.total_invoice)
                energySubscription += parseFloat(placeEnergyYear.subscription_invoice)
              }
            })
            energyConsumptions.annualConsumptions.push(energyConsumption)
            energiesOutgoings.annualOutgoings.push(energyOutgoing)
            energiesSubscriptions.annualSubscriptions.push(energySubscription)
          }
        })
        energyConsumptions.annualConsumptions = energyConsumptions.annualConsumptions.slice(sliceMin, sliceMax)
        energiesOutgoings.annualOutgoings = energiesOutgoings.annualOutgoings.slice(sliceMin, sliceMax)
        energiesSubscriptions.annualSubscriptions = energiesSubscriptions.annualSubscriptions.slice(sliceMin, sliceMax)

        siteConsumptions.energiesConsumptions.push(energyConsumptions)
        siteConsumptions.energiesOutgoings.push(energiesOutgoings)
        siteConsumptions.energiesSubscriptions.push(energiesSubscriptions)
      })

      return siteConsumptions
    }
  },
  methods: {
    paginatePrevious () {
      var app = this

      app.paginationIndexMin = Math.max(app.paginationIndexMin - app.paginationLimit, 0)
      app.paginationIndexMax = Math.max(app.paginationIndexMin + app.paginationLimit, 0)

      app.hasNextPagination = true
      if (app.paginationIndexMin === 0) {
        app.hasPreviousPagination = false
      } else {
        app.hasPreviousPagination = true
      }
    },
    paginateNext () {
      var app = this

      app.paginationIndexMin = Math.min(app.paginationIndexMin + app.paginationLimit, app.siteConsumptionsCount)
      app.paginationIndexMax = Math.min(app.paginationIndexMin + app.paginationLimit, app.siteConsumptionsCount)

      app.hasPreviousPagination = true
      if (app.paginationIndexMax === app.siteConsumptionsCount) {
        app.hasNextPagination = false
      } else {
        app.hasNextPagination = true
      }
    },
    loadApi () {
      var app = this
      var siteId = this.$route.params.siteId

      app.$store.dispatch('loading/begin_loading')

      function getEnergyList (app) {
        return session.get(`/api/parameters/energies/`).catch(function (error) { console.log(error) })
      }

      function getSiteDetails (app) {
        return session.get(`/api/userdata/sites/${siteId}/`).catch(function (error) { console.log(error) })
      }

      function getSiteConsumptions (app) {
        var queryParams = {values_type: app.valuesType}

        return session.get(`/api/userdata/sites/${siteId}/consumptions/`, {params: queryParams}).catch(function (error) { console.log(error) })
      }

      axios.all([getSiteDetails(app), getSiteConsumptions(app), getEnergyList(app)])
        .then(axios.spread(function (siteDetailsResponse, siteConsumptionsResponse, energyResponse) {
          app.siteDetails = siteDetailsResponse.data
          app.siteConsumptions = siteConsumptionsResponse.data
          app.siteConsumptionsCount = app.siteConsumptions.length
          app.energyList = energyResponse.data
          app.siteEnergyList = []

          app.energyList.forEach(function (energy) {
            app.siteConsumptions.forEach(function (consumptionYear) {
              consumptionYear.place_energy_years.forEach(function (placeEnergyYear) {
                if (placeEnergyYear.energy === energy.id && !app.siteEnergyList.includes(energy)) {
                  app.siteEnergyList.push(energy)
                }
              })
            })
          })

          app.$store.dispatch('routing/update_title', 'Site : ' + app.siteDetails.name)
          app.$store.dispatch('routing/update_return_kwargs', {name: 'Building stock sites'})

          app.hasPagination = app.siteConsumptions.length > app.paginationLimit
          app.hasNextPagination = app.hasPagination

          var colorIndex = 0
          var maxDJU = 0
          var annualConsumptions = {}
          var maxConsumption = 0

          app.consumptionChart.dataLabels = []
          app.outgoingsChart.dataLabels = []

          var djuDataSet = {
            label: 'Degrés jours',
            backgroundColor: app.energyColorList[colorIndex],
            borderColor: app.energyColorList[colorIndex],
            borderWidth: 2,
            fill: false,
            type: 'line',
            pointStyle: 'line',
            lineTension: 0,
            cubicInterpolationMode: 'linear',
            yAxisID: 'y-axis-dju',
            data: []
          }
          app.siteConsumptions.forEach(function (consumptionYear) {
            djuDataSet.data.push({x: consumptionYear.year, y: consumptionYear.degree_day})

            if (maxDJU < consumptionYear.degree_day) {
              maxDJU = consumptionYear.degree_day
            }
            app.consumptionChart.dataLabels.push(consumptionYear.year)
            app.outgoingsChart.dataLabels.push(consumptionYear.year)
            annualConsumptions[consumptionYear.year] = 0
          })

          var consumptionsDataSets = [djuDataSet]
          var outgoingsDataSets = []

          app.siteEnergyList.forEach(function (energy) {
            colorIndex += 1

            var color = app.energyColorList[colorIndex]

            var consumptionDataSet = {
              label: energy.label,
              backgroundColor: color,
              borderColor: color,
              type: 'bar',
              pointStyle: 'rect',
              yAxisID: 'y-axis-consumptions',
              data: []
            }

            var outgoingDataSet = {
              label: energy.label,
              backgroundColor: color,
              borderColor: color,
              type: 'bar',
              pointStyle: 'rect',
              yAxisID: 'y-axis-outgoings',
              data: []
            }

            app.siteConsumptions.forEach(function (consumptionYear) {
              if (consumptionYear.place_energy_years.findIndex(function (i) { return i.energy === energy.id }) !== -1) {
                var energyConsumption = 0
                var energyOutgoing = 0

                consumptionYear.place_energy_years.forEach(function (placeEnergyYear) {
                  if (placeEnergyYear.energy === energy.id) {
                    energyConsumption += parseFloat(placeEnergyYear.total_energy_consumption)
                    energyOutgoing += parseFloat(placeEnergyYear.total_invoice)
                  }
                })
                consumptionDataSet.data.push({x: consumptionYear.year, y: energyConsumption})
                outgoingDataSet.data.push({x: consumptionYear.year, y: energyOutgoing})
                annualConsumptions[consumptionYear.year] += energyConsumption
              }
            })
            consumptionsDataSets.push(consumptionDataSet)
            outgoingsDataSets.push(outgoingDataSet)
          })

          for (var year in annualConsumptions) {
            if (maxConsumption < annualConsumptions[year]) {
              maxConsumption = annualConsumptions[year]
            }
          }

          var yConsumptionsAxisMax = app.getAxisMax(maxConsumption)
          var maxYConsumptions = yConsumptionsAxisMax.max
          var yConsumptionsStep = yConsumptionsAxisMax.step

          var yDJUAxisMax = app.getAxisMax(maxDJU)
          var maxYDJU = yDJUAxisMax.max
          var yDJUStep = yDJUAxisMax.step

          var consumptionsLegend = app.valuesType === 'areal' ? 'Consommation finale totale (kWh EF / m² SU)' : 'Consommation finale totale (kWh EF)'

          // Consumptions chart
          app.consumptionChart.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            title: {display: true, text: 'Consommation d\'énergie finale (sans correction climatique)'},
            legend: {
              position: 'bottom',
              labels: {usePointStyle: true, padding: 20, fontStyle: 'bold'},
              onClick: function () {}},
            scales: {
              xAxes: [ {
                stacked: true,
                barThickness: 22
              }],
              yAxes: [{
                id: 'y-axis-consumptions',
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: consumptionsLegend,
                  fontFamily: 'Montserrat',
                  fontColor: 'black',
                  fontStyle: 'bold'
                },
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: maxYConsumptions,
                  stepSize: yConsumptionsStep
                },
                position: 'left',
                type: 'linear'
              },
              {
                id: 'y-axis-dju',
                scaleLabel: {
                  display: true,
                  labelString: 'DJU',
                  fontFamily: 'Montserrat',
                  fontColor: 'black',
                  fontStyle: 'bold'
                },
                type: 'linear',
                position: 'right',
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: maxYDJU,
                  stepSize: yDJUStep
                }
              }]
            },
            tooltips: {
              mode: 'index',
              callbacks: {
                label: function (tooltipItem, data) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || ''

                  if (label) {
                    label += ': '
                  }
                  label += parseInt(tooltipItem.yLabel)
                  return label
                }
              }
            }
          }

          app.consumptionChart.dataCollection = {
            labels: app.consumptionChart.dataLabels,
            datasets: consumptionsDataSets
          }

          var outgoingsLegend = app.valuesType === 'areal' ? 'Dépenses annuelles (€ / m² SU)' : 'Dépenses annuelles (€)'

          // OutGoingsChart
          app.outgoingsChart.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            title: {display: true, text: 'Dépenses annuelles'},
            legend: {
              position: 'bottom',
              labels: {usePointStyle: true, padding: 20, fontStyle: 'bold'},
              onClick: function () {}},
            scales: {
              xAxes: [ {
                stacked: true,
                barThickness: 22
              }],
              yAxes: [{
                id: 'y-axis-outgoings',
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: outgoingsLegend,
                  fontFamily: 'Montserrat',
                  fontColor: 'black',
                  fontStyle: 'bold'
                },
                ticks: {
                  beginAtZero: true
                },
                position: 'left',
                type: 'linear'
              }]
            },
            tooltips: {
              mode: 'index',
              callbacks: {
                label: function (tooltipItem, data) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || ''

                  if (label) {
                    label += ': '
                  }
                  label += parseInt(tooltipItem.yLabel)
                  return label
                }
              }
            }
          }

          app.outgoingsChart.dataCollection = {
            labels: app.outgoingsChart.dataLabels,
            datasets: outgoingsDataSets
          }
        })).then(function (response) {
          app.$store.dispatch('loading/end_loading')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../stylesheets/variables";
.page-content {
  overflow: auto;
  height: calc(100vh - 64 * 2px);
}

.page-layout {
  display: flex;
  height: min-content;
}

.main__panel {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 20px;
  }
}

.m-16 {
  margin-left: 16px;
  margin-top: 16px;
}

.p-10 {
  padding: 20px 40px !important;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 100%;
    background: #86ad19;
    left: 0;
    top: 0;
  }
}

.comment-icon {
  font-size: 35px !important;
  vertical-align: middle;
}

</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/BuildingStockSiteDetails.vue